var map = {
	"./accents/free.png": 4646,
	"./accents/windows.png": 3737,
	"./accents/zip.png": 7371,
	"./artifact.png": 6146,
	"./coconut.png": 4703,
	"./delval1.png": 4267,
	"./delval2.png": 768,
	"./delval3.png": 54,
	"./lom.png": 5658,
	"./orlando.png": 1013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1743;